import { Copy } from "lucide-react";
import { useEffect, useState } from "react";
import { SectionLabel } from "@/shared/ui/section-label";

/** Másolható prompt az AI-os gyakorlatoknál (design-rendszer 6.). */
export function PromptBlock({ prompt }: { prompt: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex flex-col gap-2.5 rounded-lg border border-line bg-paper p-3.5">
      <div className="flex items-center justify-between gap-3">
        <SectionLabel>Prompt az AI-hoz</SectionLabel>
        <button
          type="button"
          onClick={() => void copy()}
          className="flex h-9 items-center gap-1.5 rounded-sm border border-ink px-2.5 text-[13px] font-semibold text-ink"
        >
          <Copy size={16} />
          {copied ? "Másolva" : "Másolás"}
        </button>
      </div>
      <pre className="whitespace-pre-wrap font-mono text-[13px] leading-[1.5] text-ink">
        {prompt}
      </pre>
    </div>
  );
}
